module.exports = __webpack_public_path__ + "012e3c66e7a8b88d182b597f404474e7.svg";